import { Component, inject, signal } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { PWAInstallStore } from '@libs/core/lib/pwa/pwa-install.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mtjr-pwa-install-button',
  standalone: true,
  imports: [
    IonButton,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonContent,
    IonText,
    TranslatePipe,
    IonIcon,
    IonCard,
  ],
  template: `
    <ion-button (click)="handleInstall()">
      {{ pwaInstallStore.installButtonText() | translate }}
    </ion-button>

    <ion-modal
      [isOpen]="isInstructionsModalOpen()"
      cssClass="round-dialog"
      [backdropDismiss]="true"
      [breakpoints]="[0, 0.4]"
      [initialBreakpoint]="0.4"
      [expandToScroll]="false"
      (didDismiss)="isInstructionsModalOpen.set(false)"
    >
      <ng-template>
        <ion-header [translucent]="true">
          <ion-toolbar>
            <ion-title>{{ 'PWA.INSTRUCTIONS_HEADER' | translate }}</ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="isInstructionsModalOpen.set(false)">{{ 'COMMON.CLOSE' | translate }}</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>

        <ion-content scrollY="false">
          <div class="p-4 flex flex-col items-start">
            <div class="flex">
              <div class="flex items-center">
                <ion-text class="my-2 me-2 text-lg">- {{ 'PWA.IOS_INSTRUCTIONS_STEP_1' | translate }}</ion-text>
                <div class="py-2 px-3 bg-surface rounded-md">
                  <ion-icon name="share-ios" class="text-lg"></ion-icon>
                </div>
              </div>
            </div>
            <ion-text class="my-2">- {{ 'PWA.IOS_INSTRUCTIONS_STEP_2' | translate }}</ion-text>
            <ion-card class="rounded-md !my-2">
              <div class="flex items-center px-3 py-2">
                <ion-text>{{ 'PWA.ADD_TO_HOME_SCREEN' | translate }}</ion-text>
                <ion-icon name="add-square" class="ms-3 text-lg"></ion-icon>
              </div>
            </ion-card>
            <ion-text class="my-2">- {{ 'PWA.IOS_INSTRUCTIONS_STEP_3' | translate }}</ion-text>
            <ion-text class="my-2">- {{ 'PWA.IOS_INSTRUCTIONS_STEP_4' | translate }}</ion-text>
          </div>
        </ion-content>
      </ng-template>
    </ion-modal>
  `,
})
export class PwaInstallButtonComponent {
  pwaInstallStore = inject(PWAInstallStore);
  isInstructionsModalOpen = signal(false);

  handleInstall() {
    if (this.pwaInstallStore.isIOS()) {
      this.isInstructionsModalOpen.set(true);
    } else {
      this.pwaInstallStore.promptInstall();
    }
  }
}
